module.exports = __webpack_public_path__ + "media/images/arrow-right-39062eb5f81aedf96d9c53e91b41f8dc.svg";